// Trains/éléments
export const EDIT_USED_TRAIN = 'editUsedTrain';

// Exports
export const EXPORT_OP = 'exportOP';
export const EXPORT_MAD = 'exportAvailabilityNp';

// Menu
export const SHOW_DASHBOARD = 'showDashboard';
export const SHOW_OP = 'showSpecialOperationType';
export const SHOW_RS = 'showRS';
export const SHOW_HABILITY = 'showHability';
export const SHOW_SETTINGS = 'showSettings';
export const SHOW_ESPACE3 = 'showEspace3';
export const SHOW_RESOLVED_INCIDENT = 'showResolvedIncident';
export const EDIT_RESOLVED_INCIDENT = 'editResolvedIncident';

//Availability
export const CREATE_AVAILABILITY = 'createAvailability';
export const CREATE_MULTIPLE_AVAILABILITY = 'createMultipleAvailability';

//Special operation type
export const CLOSE_SPECIAL_OPERATION_TYPE = 'closeSpecialOperationType';
export const CREATE_SPECIAL_OPERATION_TYPE = 'createSpecialOperationType';
export const UPDATE_SPECIAL_OPERATION_TYPE = 'updateSpecialOperationType';

//Special operation
export const DISPLAY_SPECIAL_OPERATION = 'showSpecialOperation';
